"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Card = require("material-ui/Card");

var _Tabs = require("material-ui/Tabs");

var _electrify = require("./electrify");

var _electrify2 = _interopRequireDefault(_electrify);

var _modulesByPkg = require("./modules-by-pkg");

var _modulesByPkg2 = _interopRequireDefault(_modulesByPkg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(_Card.CardHeader, { showExpandableButton: true, actAsExpander: true, subtitle: "Modules" });

var WebpackModules = function WebpackModules(props) {
  return _react2.default.createElement(
    _Card.Card,
    { initiallyExpanded: true },
    _ref,
    _react2.default.createElement(
      _Card.CardText,
      { expandable: true },
      _react2.default.createElement(
        _Tabs.Tabs,
        null,
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Electrify" },
          _react2.default.createElement(_electrify2.default, { pureWebpackStats: props.pureWebpackStats })
        ),
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Modules By Pkg" },
          _react2.default.createElement(_modulesByPkg2.default, { modulesByPkg: props.modulesByPkg, totalSize: props.totalSize })
        )
      )
    )
  );
};

WebpackModules.propTypes = {
  pureWebpackStats: _react.PropTypes.object,
  modulesByPkg: _react.PropTypes.object,
  totalSize: _react.PropTypes.number
};

exports.default = WebpackModules;


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/components/sub-components/modules.js
// module id = 613
// module chunks = 0